var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotExist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 114,
    viewBox: "0 0 167 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9346 99.4372C78.5488 99.4372 100.935 77.1774 100.935 49.7186C100.935 22.2598 78.5488 0 50.9346 0C23.3203 0 0.93457 22.2598 0.93457 49.7186C0.93457 77.1774 23.3203 99.4372 50.9346 99.4372Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9346 99.4372C78.5488 99.4372 100.935 77.1774 100.935 49.7186C100.935 22.2598 78.5488 0 50.9346 0C23.3203 0 0.93457 22.2598 0.93457 49.7186C0.93457 77.1774 23.3203 99.4372 50.9346 99.4372Z",
    fill: "#DDDDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9346 99.4372C78.5488 99.4372 100.935 77.1774 100.935 49.7186C100.935 22.2598 78.5488 0 50.9346 0C23.3203 0 0.93457 22.2598 0.93457 49.7186C0.93457 77.1774 23.3203 99.4372 50.9346 99.4372Z",
    fill: "#DDDDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9346 99.4372C78.5488 99.4372 100.935 77.1774 100.935 49.7186C100.935 22.2598 78.5488 0 50.9346 0C23.3203 0 0.93457 22.2598 0.93457 49.7186C0.93457 77.1774 23.3203 99.4372 50.9346 99.4372Z",
    fill: "#DDDDDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9346 99.4372C78.5488 99.4372 100.935 77.1774 100.935 49.7186C100.935 22.2598 78.5488 0 50.9346 0C23.3203 0 0.93457 22.2598 0.93457 49.7186C0.93457 77.1774 23.3203 99.4372 50.9346 99.4372Z",
    fill: "#DDDDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9346 99.4372C78.5488 99.4372 100.935 77.1774 100.935 49.7186C100.935 22.2598 78.5488 0 50.9346 0C23.3203 0 0.93457 22.2598 0.93457 49.7186C0.93457 77.1774 23.3203 99.4372 50.9346 99.4372Z",
    fill: "#DDDDDD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1758 36L36.8768 64.299",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.877 36.0001L65.1759 64.299",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9656 93C100.199 82.1092 107.935 66.0401 107.935 48.1163C107.935 46.6182 107.881 45.1347 107.774 43.6642L97.5368 42L85.6252 46.2013L77.6995 53.2848L74.0421 62.1238L72.9346 70.0704L74.5118 77.7809L77.4694 83.4234L81.8694 88.5007L87.9656 93Z",
    fill: "#DDDDDD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.072 94.5447L141.651 100.078L118.836 85.8806L122.256 80.3489L145.072 94.5447Z",
    fill: "#D7B4F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M119.179 86.0935L132.573 86.7674L122.599 80.5618C122.598 80.5618 120.996 83.8479 119.179 86.0935Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M99.161 94.2053C113.137 94.2053 124.467 82.8398 124.467 68.8197C124.467 54.7996 113.137 43.434 99.161 43.434C85.1852 43.434 73.8555 54.7996 73.8555 68.8197C73.8555 82.8398 85.1852 94.2053 99.161 94.2053Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M108.682 88.6913C104.127 90.0118 99.4202 90.3047 94.7232 89.6885C90.2257 89.0978 85.4161 87.7405 81.6527 85.1139C80.0897 84.0223 78.6539 82.7514 77.4756 81.2516C80.7738 86.7577 86.142 91.0202 92.8318 92.7552C103.021 95.3962 113.365 91.4203 119.346 83.4989C116.203 85.8934 112.446 87.5997 108.682 88.6913Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 110.027L164.088 112.412C163.115 113.987 161.051 114.472 159.482 113.496L136.093 98.9431C135.836 98.7831 135.755 98.4422 135.916 98.1829L140.338 91.0313C140.499 90.772 140.837 90.692 141.096 90.8537L164.484 105.406C166.054 106.383 166.537 108.451 165.563 110.027Z",
    fill: "#351F67"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M145.235 93.1858L140.234 101.275L139.265 100.672L144.266 92.5824L145.235 93.1858Z",
    fill: "#E2E0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M147.53 94.6823L142.529 102.773L141.559 102.17L146.561 94.0805L147.53 94.6823Z",
    fill: "#E2E0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.218 83.166C114.332 95.9196 97.5739 99.8603 84.8607 91.9501C72.1476 84.0383 68.2184 67.2271 76.1041 54.4735C83.9899 41.7198 100.748 37.7792 113.461 45.6894C126.174 53.5996 130.104 70.4123 122.218 83.166ZM78.2064 55.7812C71.0401 67.3728 74.6088 82.6522 86.1646 89.8421C97.7188 97.0321 112.951 93.4499 120.117 81.8599C127.284 70.2683 123.715 54.9889 112.159 47.799C100.603 40.609 85.3726 44.1896 78.2064 55.7812Z",
    fill: "#351F67"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M101.927 47.0435C98.3129 46.1247 94.3467 46.6257 90.9454 48.1159C88.011 49.4012 85.1571 51.8453 84.3233 55.0529C84.1961 55.5395 84.7852 56.0933 85.2086 55.6563C87.1901 53.6124 89.2875 51.8181 91.9322 50.7009C94.9567 49.4236 98.1551 49.558 101.354 49.7277C102.862 49.8093 103.491 47.442 101.927 47.0435Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0242 93.8837C85.2278 93.8837 74.002 82.6234 74.002 68.7829C74.002 54.9425 85.2262 43.6822 99.0242 43.6822C112.821 43.6822 124.046 54.9425 124.046 68.7829C124.046 82.6234 112.821 93.8837 99.0242 93.8837ZM99.0242 44.1592C85.4901 44.1592 74.4784 55.205 74.4784 68.7829C74.4784 82.3609 85.4901 93.4067 99.0242 93.4067C112.558 93.4067 123.57 82.3609 123.57 68.7829C123.57 55.205 112.558 44.1592 99.0242 44.1592Z",
    fill: "#D7B4F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotExist);
export default __webpack_public_path__ + "static/media/not-exist.eb9143a2dc5063e002835c77bb742ef5.svg";
export { ForwardRef as ReactComponent };